import request from './index'

const PREFIX = '/v1/export-tasks'

/** 创建 Excel 导出任务 POST /v1/export-tasks/create */
export function createSearchExportTask(body) {
  return request({
    url: `${PREFIX}/create`,
    method: 'post',
    data: body,
  })
}

/** 导出任务列表 GET /v1/export-tasks/list */
export function getExportTaskList(params) {
  return request({
    url: `${PREFIX}/list`,
    method: 'get',
    params,
  })
}

/** 查询导出任务详情（轮询） GET /v1/export-tasks/{task_no} */
export function getExportTaskDetail(taskNo) {
  return request({
    url: `${PREFIX}/${encodeURIComponent(taskNo)}`,
    method: 'get',
  })
}

/** 获取导出文件下载地址 GET /v1/export-tasks/{task_no}/download */
export function getExportTaskDownloadUrl(taskNo) {
  return request({
    url: `${PREFIX}/${encodeURIComponent(taskNo)}/download`,
    method: 'get',
  })
}
